export enum Months {
    January = 'Januari',
    February = 'Februari',
    Maart = 'Maart',
    April = 'April',
    Mei = 'Mei',
    Juni = 'Juni',
    Juli = 'Juli',
    Augustus = 'Augustus',
    September = 'September',
    Oktober = 'Oktober',
    November = 'November',
    December = 'December',
}
